const chordReducer = (state, action) => {
  switch (action.type) {
    case "KEY":
      return action.keyValue;
    case "QUALITY":
      return action.qualityValue;
    case "BASS":
      return action.bassValue;
    default:
      return state;
  }
};

export default chordReducer;